import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/ui/vector/vector.tsx");
